<div class="min-height-250 position-absolute w-100" style="background: var(--banner-background)">
  <div class="wakeup" *ngIf="!signedIn && showmessage && !isErrorSolver">
    <h5 style="color: var(--header-font-color)">
      @if (global.isWhiteLabelVsvw) {
        Even geduld...<br />Je kan je zometeen aanmelden.
      } @else {
        Even geduld... Assist is aan het ontwaken.<br />Je kan je zometeen aanmelden.
      }
    </h5>
  </div>
</div>
@if (isErrorSolver && !signedIn) {
  <main class="main-content position-relative border-radius-lg">
    <div class="mx-4" style="padding-top: 75px">
      <app-local-storage-reset></app-local-storage-reset>
    </div>
  </main>
} @else {
  <aside
    class="d-flex sidenav bg-white navbar navbar-vertical navbar-expand-xs border-0 border-radius-xl my-3 fixed-start ms-4"
    id="sidenav-main"
    *ngIf="signedIn"
  >
    <div class="align-self-start flex-fill">
      <app-sidenav
        [menuItems]="menuItems"
        (appClickOutside)="onClickOutsideSideNav($event)"
      ></app-sidenav>
    </div>
    <!-- ONZICHTBAAR GEMAAKT DOOR VINCENT - HIER MOET EEN ICON KOMEN VAN DE FEDERATIE
      <div class="align-self-end mt-5 mx-4">
          <a href="https://www.vlaamsesportfederatie.be/" target="_blank">
              <img src="../../../../../assets/img/icon-vsf.png" class="logo-partner mb-4">
          </a>
      </div>
      -->
  </aside>
  <main class="main-content position-relative border-radius-lg" *ngIf="signedIn && loaded">
    <app-navbar></app-navbar>
    <div class="container-fluid mb-5 pb-2">
      <div class="row mb-5">
        <router-outlet></router-outlet>
      </div>
      <div class="d-none text-end pt-5">
        <small class="pt-5 text-muted">{{ version }}</small>
      </div>
    </div>
  </main>
}
<!-- <app-plugin></app-plugin> -->
